import type { DeviceInfo } from '@pingo/shared';

const KEY = 'pingo.deviceId';

/** Stable per-browser device id (sent with logins and scorer ops for the audit log). */
export function deviceId(): string {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return 'no-storage';
  }
}

export function deviceInfo(): DeviceInfo {
  return {
    deviceId: deviceId(),
    userAgent: navigator.userAgent.slice(0, 400),
    platform:
      (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData
        ?.platform ?? navigator.platform,
    screen: `${window.screen.width}x${window.screen.height}`,
    online: navigator.onLine,
    standalone: window.matchMedia?.('(display-mode: standalone)').matches ?? false,
    appVersion: import.meta.env.VITE_APP_VERSION ?? 'dev',
  };
}
